import { WebSocketContext } from '@/providers/WebSocketProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

import { StyledHeader } from './StyledHeader';

const voiceToolkitMenus = [
  { url: '/mss', label: 'MSS & SE' },
  { url: '/cvc', label: 'VOICE CONVERSION' },
];
const Header = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { connectionStatus } = useContext(WebSocketContext);

  return (
    <StyledHeader>
      <ul>
        {voiceToolkitMenus.map(({ url, label }) => {
          return (
            <li
              key={`key_nav_${url}`}
              className={url === pathname ? 'selected' : ''}
            >
              <NavLink to={url}>{t(label)}</NavLink>
            </li>
          );
        })}
      </ul>
      {/* Live region stays mounted so screen readers announce both the
          outage and the recovery (ISSUE-022). */}
      <span className="connection-status" role="status">
        {connectionStatus === 'disconnected'
          ? t('Live updates unavailable. Reconnecting...')
          : ''}
      </span>
    </StyledHeader>
  );
};

export default Header;
